import { createSlice } from '@reduxjs/toolkit';
import extraReducers from './extraReducers';

const initialState = {
  loiTemplates: [],
  status: 'idle',
  loading: false,
  error: null,
};

const loiTemplateSlice = createSlice({
  name: 'loi_template',
  initialState,
  reducers: {},
  extraReducers,
});

export {
  fetchLoiTemplates,
  createLoiTemplate,
  deleteLoiTemplate,
} from './extraReducers';

export default loiTemplateSlice.reducer;
